import { createContext } from 'react'

import { InsightsConversationsQuery } from '@driftt/insights-components'

import { IQueryConfig } from 'api/report/query/types'

export interface IConversationResultsContext {
  setQuery: (query: InsightsConversationsQuery) => void
  setQueryConfig: (queryConfig: IQueryConfig) => void
}

const ConversationResultsContext = createContext<IConversationResultsContext>({
  setQueryConfig: () => null,
  setQuery: () => null,
})

export default ConversationResultsContext
